var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h4v2H7a3 3 0 1 0 0 6h4v2H7A5 5 0 0 1 7 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12a3 3 0 0 1-3 3h-4v2h4a5 5 0 0 0 0-10h-4v2h4a3 3 0 0 1 3 3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H9v2h6v-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionLink);
export default __webpack_public_path__ + "static/media/ic_action_link.40f862c40b8f578128bf767d2fb78915.svg";
export { ForwardRef as ReactComponent };